import { Orientation } from "@microsoft/fast-web-utilities";
import { ValuesOf } from "../../foundation/random";

/**
 * Radio Group orientation
 * @public
 */
export const RadioGroupOrientation = Orientation;

/**
 * Types of Radio Group orientation
 * @public
 */
export type RadioGroupOrientation = ValuesOf<typeof RadioGroupOrientation>;
